module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ROiYY4/tc-custom/9781488086267.jpg?1728259357435",
      "alt": "This image is the cover for the book Her Stolen Past, Family Reunions"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Her Stolen Past, Family Reunions\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Uncovering her family’s connection to a kidnapped baby leads a young woman into deadly peril in this inspiring romantic suspense series finale.")]), _c('br'), _c('br'), _vm._v("Sorting through her late mother’s home, Sonya Daniels expected to find loose ends and even a few surprises—but nothing prepared her for the shock of uncovering the birth certificate of a kidnapped baby. What was her family’s connection to the child, still missing for over two decades? And what happened to the little girl? "), _c('br'), _c('br'), _vm._v("Sonya hires detective Brandon Hayes to help her get to the truth. But someone doesn’t want the truth to come out and will stop at nothing to keep them from investigating. Sonya knows the guarded cop won’t rest until he unravels the mystery—but the answers could be more than she can bear alone.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lynette Eason\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Lynette Eason lives in Simpsonville, SC with her husband and two children. She is an award-winning, best-selling author who spends her days writing when she's not traveling around the country teaching at writing conferences. Lynette enjoys visits to the mountains, hanging out with family and brainstorming stories with her fellow writers. You can visit Lynette's website to find out more at www.lynetteeason.com or like her Facebook page at www.facebook.com/lynette.eason")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises Limited\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0